import { ErpSyncStatus } from '@40seas/entities/erp-sync';
import { EnumColor } from '@40seas/frontend/common/providers';

export const erpSyncStatusColorMapping = {
    [ErpSyncStatus.Pending]: 'info',
    [ErpSyncStatus.InProgress]: 'default',
    [ErpSyncStatus.PendingSummary]: 'info',
    [ErpSyncStatus.Completed]: 'success',
    [ErpSyncStatus.Timeout]: 'warning',
    [ErpSyncStatus.Failed]: 'error',
} as { [key in ErpSyncStatus]: EnumColor };
